import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["paybackPrice", "totalPaybackDisplay"]
  static values = { quantity: Number, currency: String }

  connect() {
    this.updatePayback()
  }

  updatePayback() {
    const paybackPrice = this.hasPaybackPriceTarget ? Number(this.paybackPriceTarget.value || 0) : 0
    const total = paybackPrice * (this.quantityValue || 0)

    if (this.hasTotalPaybackDisplayTarget) {
      this.totalPaybackDisplayTarget.textContent = this.formatCurrency(total)
    }
  }

  formatCurrency(amount) {
    if (!Number.isFinite(amount)) return ""

    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: this.currencyValue || "AUD"
    }).format(amount)
  }
}
